var map = {
	"./banner-box-1.svg": 9175,
	"./banner-box-2.svg": 964,
	"./banner-box-3.svg": 7221,
	"./banner-box-4.svg": 362,
	"./banner-box-5.svg": 731,
	"./banner-box-6.png": 4983,
	"./bg-box-icon.svg": 9608,
	"./bg-footer.svg": 846,
	"./bg-header-gray-lg.svg": 4370,
	"./bg-header-gray.svg": 2996,
	"./bg-header-lg.svg": 3438,
	"./bg-header.svg": 1776,
	"./bg-newsletter.svg": 7478,
	"./bg-scrollbar-thumb.svg": 5196,
	"./bg-section-check-for-new-extensions-before.svg": 4941,
	"./bg-section-select-your-theme-after.svg": 9014,
	"./bg-section-select-your-theme-before.svg": 9513,
	"./bg-section-subscribe-newsletter-before.svg": 1999,
	"./bg-section-veello-theme-insights-after.svg": 5677,
	"./bg-section-veello-theme-insights-before.svg": 3456,
	"./bg-section-why-choose-us-after.svg": 6295,
	"./bg-section-why-choose-us-before.svg": 8558,
	"./bg-veelloman-left.svg": 506,
	"./bg-veelloman.svg": 5472,
	"./logo-isotope.svg": 6936,
	"./logo-light.svg": 3913,
	"./logo-payment-footer.svg": 1561,
	"./logo-payment-paypal.svg": 7229,
	"./logo-payment-stripe-card.svg": 3046,
	"./logo-payment-stripe.svg": 3467,
	"./logo-signet.svg": 7515,
	"./logo-white.svg": 7742,
	"./logo.svg": 6994,
	"./text-meet-veelloman.svg": 6204,
	"./veelloman-home.png": 9719
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1597;